module.exports = __webpack_public_path__ + "images/sichuan_banner01.jpg?8467c9982498c098e811002249eb4208";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/sichuan_banner01.jpg
// module id = 193
// module chunks = 1